import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SuggestionCard from "../components/common/SuggestionCard";
import { useProduct } from "../context/ProductContext";
import { useNavigate } from "react-router-dom";

function OthersDetailPage() {
  // 1. Obtener parámetros
  const { id, cat } = useParams();
  const { drinks, desserts, extras } = useProduct();
  const navigate = useNavigate();

  //Obtener de localstorage los productos por si se recarga la página

  // 2. Estados (hooks primero)
  const [product, setProduct] = useState({});
  const [quantity, setQuantity] = useState(1);
  const [key, setKey] = useState(0);

  //métodos para efecto
  const findProduct = () => {
    let findProduct = [];

    switch (cat) {
      case "drink":
        findProduct = drinks.filter((drink) => drink.id == id);
        break;
      case "dessert":
        findProduct = desserts.filter((dessert) => dessert.id == id);
        break;
      case "extra":
        findProduct = extras.filter((extra) => extra.id == id);
        break;
      default:
        throw new Error("Categoría no válida");
    }
    if (!findProduct[0]?.id) {
      alert("Al recargar la página regresarás al menú");
      navigate("/menu");
    } else {
      setQuantity(quantity + 1);
      setProduct({
        productId: findProduct[0].id,
        productName: findProduct[0].name,
        description: findProduct[0].description,
        cat: cat,
        size: "Unidad",
        quantity: quantity,
        price: findProduct[0].price || 0,
        image: findProduct[0].image_link,
      });
    }
  };

  const remountComponent = () => {
    setKey((prevKey) => prevKey + 1);
  };

  // 3. Efecto para cargar el producto, como condicion el efecto se producira cuando los parametros
  //categoría e id cambien

  useEffect(() => {
    findProduct();
    setQuantity(1);
    remountComponent();
  }, [id, cat]);

  //sumar cantidad

  const handleQuantityPlus = () => {
    setQuantity(quantity + 1);
    setProduct((prevState) => ({
      ...prevState, // Copia las propiedades anteriores
      quantity: quantity + 1, // Actualiza solo la propiedad deseada
    }));
  };

  //restar cantidad
  const handleQuantityMinus = () => {
    setQuantity(quantity - 1);
    setProduct((prevState) => ({
      ...prevState, // Copia las propiedades anteriores
      quantity: quantity - 1, // Actualiza solo la propiedad deseada
    }));
  };

  // 4. Función para guardar en localStorage
  const saveToLocalStorage = (item) => {
    //obtenemos el carrito desde localstorage
    const cart = JSON.parse(localStorage.getItem("pizzaDeliciaCart") || "[]");

    //se busca el producto en el array con el mismo id y la misma categoria
    const existingIndex = cart.findIndex(
      (i) => i.productId === item.productId && i.cat === item.cat,
    );

    console.log(`El indice es: ${existingIndex} la categoria es: ${cat}`);

    //se comprueba que el mismo producto sea agregado para solo sumar la cantidad
    if (existingIndex > -1 && existingIndex < existingIndex + 1) {
      cart[existingIndex].quantity += quantity;
    } else {
      //si es un producto diferente se agrega en un nuevo índice del array
      cart.push(item);
    }
    //se actualiza el carrito en el local storage
    localStorage.setItem("pizzaDeliciaCart", JSON.stringify(cart));
  };

  // 5. Manejar agregar al carrito
  const handleAddToCart = () => {
    if (!product.productId) {
      alert("Producto no disponible");
      return;
    }
    if (quantity === 0) {
      alert("selecciona la cantidad de productos");
      return;
    }
    alert(`¡${product.productName} agregado al carrito!`);
    saveToLocalStorage(product);
    setQuantity(1);
  };

  // 8. Precio del producto
  const price = product.price || 0;

  console.log(product);

  if (drinks.length === 0 || desserts.length === 0 || extras.length === 0) {
    return <h1 className="page-padding">Redirigiendo...</h1>;
  }

  return (
    <div className="product-detail-page-container page-padding">
      <div
        className="product-detail-main d-flex flex-row justify-content-evenly flex-wrap"
        style={{ marginBottom: "40px" }}
      >
        <div className="product-detail-image">
          <img
            className="rounded"
            src={product.image}
            alt={product.productName}
            width="473"
            height="275"
            style={{ objectFit: "cover" }}
            onError={(e) => {
              e.target.src =
                "https://via.placeholder.com/473x275?text=Imagen+no+disponible";
            }}
          />
        </div>

        <div className="product-detail-info">
          <h1>{product.productName}</h1>
          <p className="product-description fs-6">{product.description}</p>

          <p className="product-price-display fs-5">${price} MXN</p>

          <div className="cart-controls">
            <button
              onClick={handleQuantityMinus}
              className="btn-quantity-control btn btn-secondary"
              style={{ margin: "5px" }}
              disabled={quantity <= 1}
            >
              -
            </button>
            <span className="current-quantity" style={{ margin: "5px" }}>
              {quantity}
            </span>
            <button
              onClick={handleQuantityPlus}
              className="btn-quantity-control btn btn-secondary"
              style={{ margin: "5px" }}
              disabled={quantity >= 10}
            >
              +
            </button>
          </div>

          <button
            className="btn btn-add-cart"
            onClick={handleAddToCart}
            style={{ width: "100%" }}
          >
            Agregar al carrito
          </button>
        </div>
      </div>

      <section className="suggestions-section">
        <h2 style={{ marginBottom: "10px" }}>
          Sugerencias para agregar a tu pedido
        </h2>
        <div className="suggestions-grid d-flex justify-content-evenly flex-wrap">
          <SuggestionCard key={key} />
        </div>
      </section>
    </div>
  );
}

export default OthersDetailPage;
